import { lazy } from "react";

const Dashboard = lazy(() => import("@pages/Dashboard"));
const Analytics = lazy(
  () => import("@pages/Analytics/AnalyticsDashboard/AnalyticsDasboard"),
);
const RecipientsEmails = lazy(
  () => import("@pages/Analytics/RecipientsEmails"),
);
const AnalyticsInsights = lazy(() => import("@pages/Analytics/Insights"));
const POSAnalytics = lazy(() => import("@pages/Analytics/POSAnalytics"));
const MarketingPopups = lazy(() => import("@pages/MarketingPopups"));
const BrandingMarketing = lazy(
  () => import("@pages/WebsiteCMS/BrandingMarketing"),
);
const TemplateManager = lazy(() => import("@pages/WebsiteCMS/TemplateManager"));
const UserSettings = lazy(() => import("@pages/UserProfile/userSettings"));
const UserBooking = lazy(() => import("@pages/UserProfile/UserBookings"));
const UserLanguage = lazy(() => import("@pages/UserProfile/UserLanguage"));
const Pricing = lazy(() => import("@pages/UserProfile/Pricing"));
const DynamicRules = lazy(
  () => import("@pages/UserProfile/Pricing/DynamicRules"),
);
const BookingListView = lazy(() => import("@pages/Bookings/Booking"));
const OperationView = lazy(() => import("@pages/Bookings/OperationHours2"));
const WaillistView = lazy(() => import("@pages/Bookings/Waitlist"));
const CancellationView = lazy(() => import("@pages/Bookings/Cancellations"));
const AllCustomers = lazy(() => import("@pages/Customers/CustomerList"));
const MembersCustomer = lazy(() => import("@pages/Customers/CustomerMembers"));
const Members = lazy(() => import("@pages/Memberships/CustomerMembers"));
const StandardCustomer = lazy(() => import("@pages/Customers/non-members"));
const FailedLogins = lazy(() => import("@pages/Customers/FailedLogins"));
const MembershipPlans = lazy(
  () => import("@pages/Memberships/PlansMembership"),
);

const CalendarView = lazy(
  () => import("@pages/Bookings/Booking/BookingCalendar/BookingCalendarView"),
);

const TransactionList = lazy(
  () => import("@pages/Transaction/TransactionList"),
);
const PosPage = lazy(() => import("@pages/POS/index"));
const LeagueManagerPage = lazy(() => import("@pages/LeagueManager/index"));
const SocialMinerPage = lazy(() => import("@pages/SocialMiner/index"));
const MarketingEnginePage = lazy(() => import("@pages/SocialMiner/index"));
const ReportingPage = lazy(() => import("@pages/Reporting/index"));
const LoginPage = lazy(() => import("@pages/auth/LoginPage"));
const RegisterPage = lazy(() => import("@pages/auth/RegisterPage"));
const VerificationOtpPage = lazy(
  () => import("@pages/auth/VerificationOtpPage"),
);
const ConfirmationPage = lazy(() => import("@pages/auth/ConfirmationPage"));
const ResetPassword = lazy(() => import("@pages/auth/ResetPassword"));
const PasswordVerification = lazy(
  () => import("@pages/auth/PasswordVerification"),
);
const NewPassword = lazy(() => import("@pages/auth/NewPassword"));
const UserInvitePage = lazy(() => import("@pages/auth/UserInvitePage"));
const GoogleCallback = lazy(() => import("@pages/auth/GoogleCallback"));
const AccountPicker = lazy(() => import("@pages/auth/AccountPicker"));
const Errorpage = lazy(() => import("@pages/ErrorPage"));

const LeaguesEventsCalendarView = lazy(
  () => import("@pages/LeaguesEvents/CalendarEvents/LeagueCalendarView"),
);
const EventContactView = lazy(
  () => import("@pages/LeaguesEvents/EventContact/index"),
);
// const Subscribers = lazy(
//   () => import("@pages/LeaguesEvents/Subscribers/index")
// );
const LeagueEventsList = lazy(
  () => import("@pages/LeaguesEvents/LeagueEventsList/LeagueEventsList"),
);

const Venue = lazy(() => import("@pages/UserProfile/Venue"));
const Notifications = lazy(() => import("@pages/UserProfile/Notifications"));
const Contactforms = lazy(() => import("@pages/inbox/ContactForm/index"));
const Newsletter = lazy(() => import("@pages/inbox/Newsletter/index"));
const Leagues = lazy(() => import("@pages/inbox/Leagues/index"));
const Events = lazy(() => import("@pages/inbox/Events/index"));
const BookingsMonthlyCalendarView = lazy(
  () => import("@pages/Bookings/Booking/BookingCalendar/BookingMonthlyView"),
);

const Notification = lazy(
  () => import("@pages/Notification/NotificationPage/index"),
);
const NotAuthorized = lazy(() => import("@pages/NotAuthorized"));

const LessonsCalendar = lazy(
  () => import("@pages/Lessons/Lessons&Fittings/CalendarView/index"),
);
const LessonsList = lazy(
  () => import("@pages/Lessons/Lessons&Fittings/ListView/index"),
);
const Coaches = lazy(() => import("@pages/Lessons/Coaches/index"));
const Availability = lazy(() => import("@pages/Lessons/Availability/index"));

// Golf Course Management Pages
const OutdoorDashboard = lazy(() => import("@pages/Dashboard/Outdoor/index"));
const GolfDashboard = lazy(() => import("@pages/Golf/Dashboard/index"));
const BaysDashboard = lazy(() => import("@pages/Bays/Dashboard/index"));
const TeeTimes = lazy(() => import("@pages/Golf/TeeTimes/index"));
const TeeTimesCalendar = lazy(
  () => import("@pages/Golf/TeeTimes/Calendar/index"),
);
const TeeTimesList = lazy(() => import("@pages/Golf/TeeTimes/List/index"));
const TeeTimesConfig = lazy(() => import("@pages/Golf/TeeTimes/Config/index"));
const Courses = lazy(() => import("@pages/Golf/Courses/index"));
const Carts = lazy(() => import("@pages/Golf/Carts/index"));
const Caddies = lazy(() => import("@pages/Golf/Caddies/index"));
const CaddiesOverview = lazy(
  () => import("@pages/Golf/Caddies/Overview/index"),
);
const CaddiesAvailability = lazy(
  () => import("@pages/Golf/Caddies/Availability/index"),
);
const CaddiesAssignments = lazy(
  () => import("@pages/Golf/Caddies/Assignments/index"),
);
const CaddiesSchedule = lazy(
  () => import("@pages/Golf/Caddies/Schedule/index"),
);
const CaddiesPayroll = lazy(() => import("@pages/Golf/Caddies/Payroll/index"));
const CaddiesCertifications = lazy(
  () => import("@pages/Golf/Caddies/Certifications/index"),
);
const CaddiesSettings = lazy(
  () => import("@pages/Golf/Caddies/Settings/index"),
);
const StaffScheduler = lazy(() => import("@pages/Golf/StaffScheduler/index"));
const Weather = lazy(() => import("@pages/Golf/Weather/index"));
const GolfOperationHours = lazy(
  () => import("@pages/Golf/OperationHours/index"),
);
const GolfWaitlist = lazy(() => import("@pages/Golf/Waitlist/index"));
const GolfCancelations = lazy(() => import("@pages/Golf/Cancelations/index"));
const GolfTV = lazy(() => import("@pages/Golf/TV/index"));
const GolfPricing = lazy(() => import("@pages/Golf/Settings/Pricing/index"));
const GolfBookingSettings = lazy(
  () => import("@pages/UserProfile/CourseBookings/index"),
);
const GolfLanguageSettings = lazy(
  () => import("@pages/Golf/Settings/Language/index"),
);
const GolfNotificationSettings = lazy(
  () => import("@pages/Golf/Settings/Notifications/index"),
);
const GolfLeagues = lazy(() => import("@pages/Golf/Leagues/index"));
const GolfLeaguesOverview = lazy(
  () => import("@pages/Golf/Leagues/Overview/index"),
);
const GolfLeaguesSeasons = lazy(
  () => import("@pages/Golf/Leagues/Seasons/index"),
);
const GolfLeaguesEvents = lazy(
  () => import("@pages/Golf/Leagues/Events/index"),
);
const GolfLeaguesStandings = lazy(
  () => import("@pages/Golf/Leagues/Standings/index"),
);
const GolfLeaguesLive = lazy(() => import("@pages/Golf/Leagues/Live/index"));
const GolfLeaguesSetup = lazy(() => import("@pages/Golf/Leagues/Setup/index"));
const GolfLeaguesMemberGuest = lazy(
  () => import("@pages/Golf/Leagues/MemberGuest/index"),
);
const GolfLeaguesMemberGuestDetail = lazy(
  () => import("@pages/Golf/Leagues/MemberGuest/Detail/index"),
);
const GolfLeaguesMemberGuestCalcutta = lazy(
  () => import("@pages/Golf/Leagues/MemberGuest/Detail/Calcutta"),
);
const GolfLeaguesSchedule = lazy(
  () => import("@pages/Golf/Leagues/Schedule/index"),
);
const GolfLeaguesHandicaps = lazy(
  () => import("@pages/Golf/Leagues/Handicaps/index"),
);
const GolfLeaguesBays = lazy(() => import("@pages/Golf/Leagues/Bays/index"));
const GolfLeaguesComms = lazy(() => import("@pages/Golf/Leagues/Comms/index"));
const GolfLeaguesSideGames = lazy(
  () => import("@pages/Golf/Leagues/SideGames/index"),
);
const GolfLeaguesSponsorships = lazy(
  () => import("@pages/Golf/Leagues/Sponsorships/index"),
);
const GolfLeaguesProShop = lazy(
  () => import("@pages/Golf/Leagues/ProShop/index"),
);
const GolfLeaguesPace = lazy(() => import("@pages/Golf/Leagues/Pace/index"));
const GolfLeaguesNetwork = lazy(
  () => import("@pages/Golf/Leagues/Network/index"),
);
const GolfLeagueDetail = lazy(
  () => import("@pages/Golf/Leagues/LeagueDetail/index"),
);
const GolfSeasonDetail = lazy(
  () => import("@pages/Golf/Leagues/SeasonDetail/index"),
);
const GolfEventDetail = lazy(
  () => import("@pages/Golf/Leagues/EventDetail/index"),
);

// Unified Scheduling & Caddies (Coach Pattern)
const CaddyRosterPage = lazy(() =>
  import("@/pages/Caddies/CaddyRosterPage").then((module) => ({
    default: module.CaddyRosterPage,
  })),
);
const CaddySchedulePage = lazy(() =>
  import("@/pages/Caddies/CaddySchedulePage").then((module) => ({
    default: module.CaddySchedulePage,
  })),
);
const StaffSchedulingPage = lazy(
  () => import("@/pages/Scheduling/StaffSchedulingPage"),
);

// private routes
export const privateRoutes = [
  {
    name: "dashboard",
    path: "/dashboard",
    component: Dashboard,
    permission: { resource: "Dashboard", action: "view" },
  },
  { name: "not authorized", path: "/not-authorized", component: NotAuthorized },
  {
    name: "settings",
    path: "/settings",
    component: UserSettings,
    // No permission check - all users can access settings (Current User tab)
    // Individual tabs will show locks/view-only messages based on permissions
  },

  {
    name: "analytics",
    path: "/analytics",
    component: Analytics,
    permission: { resource: "Analytics", action: "view" },
  },
  {
    name: "insights",
    path: "/analytics/insights",
    component: AnalyticsInsights,
    permission: { resource: "Analytics", action: "view" },
  },
  {
    name: "recipients-emails",
    path: "/analytics/reports_schedule",
    component: RecipientsEmails,
    permission: { resource: "Analytics", action: "view" },
  },
  {
    name: "analytics-pos",
    path: "/analytics/pos",
    component: POSAnalytics,
    permission: { resource: "Analytics", action: "view" },
  },
  {
    name: "branding & marketing",
    path: "/website-cms/branding",
    component: BrandingMarketing,
    // TODO: Enable permission check once backend grants "Website CMS" permission to Owner/Operator
    // permission: { resource: "Website CMS", action: "view" },
  },
  {
    name: "template manager",
    path: "/website-cms/templates",
    component: TemplateManager,
    // TODO: Enable permission check once backend grants "Website CMS" permission to Owner/Operator
    // permission: { resource: "Website CMS", action: "view" },
  },
  {
    name: "marketing popups",
    path: "/website-cms/marketing-popups",
    component: MarketingPopups,
    // TODO: Enable permission check once backend grants "Marketing Popups" permission to Owner/Operator
    // permission: { resource: "Marketing Popups", action: "view" },
  },

  {
    name: "user bookings",
    path: "/settings/bookings",
    component: UserBooking,
    // No permission check - all users can view, restricted features show locks
  },
  {
    name: "user venue",
    path: "/settings/venue",
    component: Venue,
    // No permission check - all users can view, restricted features show locks
  },
  {
    name: "user notifications",
    path: "/settings/notifications",
    component: Notifications,
    // No permission check - all users can view, restricted features show locks
  },
  {
    name: "pricing",
    path: "/settings/pricing",
    component: Pricing,
    // No permission check - all users can view, restricted features show locks
  },
  {
    name: "dynamic-pricing",
    path: "/settings/pricing/dynamic",
    component: DynamicRules,
    permission: { resource: "Pricing Configuration", action: "view" },
  },
  {
    name: "user language",
    path: "/settings/language",
    component: UserLanguage,
    // No permission check - all users can view, restricted features show locks
  },
  {
    name: "bookings",
    path: "/bookings",
    component: BookingListView,
    permission: { resource: "Bookings", action: "view" },
  },
  {
    name: "operations",
    path: "/bookings/operation-hours",
    component: OperationView,
    permission: { resource: "Business Hours", action: "view" },
  },
  {
    name: "waitlist",
    path: "/bookings/waitlist",
    component: WaillistView,
    permission: { resource: "Bookings", action: "view" },
  },
  {
    name: "bookings calendar",
    path: "/booking/calendar",
    component: CalendarView,
    permission: { resource: "Bookings", action: "view" },
  },

  {
    name: "cancellations",
    path: "/bookings/cancellations",
    component: CancellationView,
    permission: { resource: "Bookings", action: "view" },
  },
  {
    name: "customers",
    path: "/customers",
    component: AllCustomers,
    permission: { resource: "Customer Management", action: "view" }, // API sends "Customer Management", not "Users"
  },
  {
    name: "customers members",
    path: "/customers/members",
    component: MembersCustomer,
    permission: { resource: "Customer Management", action: "view" }, // API sends "Customer Management", not "Users"
  },
  {
    name: "customers standard",
    path: "/customers/non-members",
    component: StandardCustomer,
    permission: { resource: "Customer Management", action: "view" }, // API sends "Customer Management", not "Users"
  },
  {
    name: "customers failed logins",
    path: "/customers/failed-logins",
    component: FailedLogins,
    permission: { resource: "Customer Management", action: "view" }, // API sends "Customer Management", not "Users"
  },
  {
    name: "events calendar",
    path: "/events/calendar",
    component: LeaguesEventsCalendarView,
    permission: { resource: "Calendar Events", action: "view" }, // API sends "Calendar Events", not "Events"
  },

  {
    name: "Lessons & Fittings",
    path: "/lessons/calendar",
    component: LessonsCalendar,
    permission: { resource: "Lesson & Coach", action: "view" }, // API sends "Lesson & Coach", not "Coaching"
  },
  {
    name: "Lessons & Fittings",
    path: "/lessons/list",
    component: LessonsList,
    permission: { resource: "Lesson & Coach", action: "view" }, // API sends "Lesson & Coach", not "Coaching"
  },
  {
    name: "Availability",
    path: "/lessons/coach-availability",
    component: Availability,
    permission: { resource: "Lesson & Coach", action: "view" }, // API sends "Lesson & Coach", not "Coaching"
  },
  {
    name: "Coaches",
    path: "/lessons/coaches",
    component: Coaches,
    permission: { resource: "Lesson & Coach", action: "view" }, // API sends "Lesson & Coach", not "Coaching"
  },
  {
    name: "league players",
    path: "/events/event-contacts",
    component: EventContactView,
    permission: { resource: "Calendar Events", action: "view" }, // API sends "Calendar Events", not "Events"
  },
  // {
  //   name: "subscribers",
  //   path: "/league/subscribers",
  //   component: Subscribers,
  // },

  {
    name: "memberships plans",
    path: "/membership/plans",
    component: MembershipPlans,
    permission: { resource: "Membership Plans", action: "view" }, // API sends "Membership Plans" (plural)
  },
  {
    name: "members",
    path: "/membership/members",
    component: Members,
    permission: { resource: "Members", action: "view" }, // API sends "Members"
  },
  {
    name: "transaction",
    path: "/transaction",
    component: TransactionList,
    permission: { resource: "Transactions", action: "view" }, // API sends "Transactions" (plural)
  },
  {
    name: "Contact Form",
    path: "/inbox/contact-form",
    component: Contactforms,
    permission: {
      anyOf: [
        {
          resource: "Subscriptions",
          subResource: "contact us manage",
          action: "view",
        },
        {
          resource: "Subscriptions",
          subResource: "contact form",
          action: "view",
        },
        {
          resource: "Subscriptions",
          subResource: "contact forms",
          action: "view",
        },
        { resource: "Subscriptions", action: "view" },
      ],
    },
  },
  {
    name: "Newsletter",
    path: "/inbox/newsletter",
    component: Newsletter,
    permission: {
      anyOf: [
        {
          resource: "Subscriptions",
          subResource: "newsletter contact form",
          action: "view",
        },
        {
          resource: "Subscriptions",
          subResource: "newsletter",
          action: "view",
        },
        { resource: "Subscriptions", action: "view" },
      ],
    },
  },
  {
    name: "Leagues",
    path: "/subscriptions/leagues",
    component: Leagues,
    permission: {
      anyOf: [
        {
          resource: "Subscriptions",
          subResource: "event subscription",
          action: "view",
        },
        {
          resource: "Subscriptions",
          subResource: "newsletter contact form",
          action: "view",
        },
        {
          resource: "Subscriptions",
          subResource: "contact us manage",
          action: "view",
        },
      ],
    },
  },
  {
    name: "Events",
    path: "/subscriptions/events",
    component: Events,
    permission: {
      resource: "Subscriptions",
      subResource: "event subscription",
      action: "view",
    },
  },
  { name: "Leagues", path: "/inbox/leagues", component: Leagues },
  { name: "Events", path: "/inbox/events", component: Events },

  {
    name: "pos",
    path: "/pos",
    component: PosPage,
    permission: { resource: "POS", action: "view" },
  },
  {
    name: "league manager",
    path: "/league-manager",
    component: LeagueManagerPage,
  },
  {
    name: "League Events",
    path: "/league-events",
    component: LeagueEventsList,
    // TODO: Backend needs to provide "Leagues" permission, or confirm this should use "Calendar Events"
    // Temporarily removed permission check to allow access
    // permission: { resource: "Leagues", action: "view" },
  },

  { name: "social miner", path: "/social-miner", component: SocialMinerPage },
  {
    name: "marketing engine",
    path: "/marketing-engine",
    component: MarketingEnginePage,
  },
  { name: "reporting", path: "/reporting", component: ReportingPage },
  {
    name: "bookings monthly calendar",
    path: "/bookings/monthly",
    component: BookingsMonthlyCalendarView,
  },
  { name: "notification", path: "/notification", component: Notification },

  // ============================================
  // Golf Course Management Routes
  // ============================================
  {
    name: "golf dashboard",
    path: "/golf/dashboard",
    component: GolfDashboard,
    // TODO: Add permission check when available
  },
  {
    name: "outdoor dashboard",
    path: "/dashboard/outdoor",
    component: OutdoorDashboard,
    // TODO: Add permission check when available
  },

  // ============================================
  // Bays Management Routes
  // ============================================
  {
    name: "bays dashboard",
    path: "/bays/dashboard",
    component: BaysDashboard,
    // TODO: Add permission check when available
  },
  {
    name: "tee times",
    path: "/golf/tee-times",
    component: TeeTimes,
    // TODO: Add permission check when available
  },
  {
    name: "tee times calendar",
    path: "/golf/tee-times/calendar",
    component: TeeTimesCalendar,
    // TODO: Add permission check when available
  },
  {
    name: "tee times list",
    path: "/golf/tee-times/list",
    component: TeeTimesList,
    // TODO: Add permission check when available
  },
  {
    name: "tee times config",
    path: "/golf/tee-times/config",
    component: TeeTimesConfig,
    // TODO: Add permission check when available
  },
  {
    name: "golf waitlist",
    path: "/golf/waitlist",
    component: GolfWaitlist,
  },
  {
    name: "golf cancelations",
    path: "/golf/cancelations",
    component: GolfCancelations,
  },
  {
    name: "golf operation hours",
    path: "/golf/operation-hours",
    component: GolfOperationHours,
  },
  {
    name: "golf tv display",
    path: "/golf/tv/:courseId?",
    component: GolfTV,
  },
  {
    name: "golf booking settings",
    path: "/golf/settings/bookings",
    component: GolfBookingSettings,
  },
  {
    name: "golf pricing",
    path: "/golf/settings/pricing",
    component: GolfPricing,
  },
  {
    name: "golf language settings",
    path: "/golf/settings/language",
    component: GolfLanguageSettings,
  },
  {
    name: "golf notification settings",
    path: "/golf/settings/notifications",
    component: GolfNotificationSettings,
  },
  {
    name: "courses",
    path: "/golf/courses",
    component: Courses,
    // TODO: Add permission check when available
  },
  {
    name: "course info",
    path: "/golf/courses/info",
    component: Courses,
    // TODO: Add permission check when available
  },
  {
    name: "courses holes",
    path: "/golf/courses/holes",
    component: Courses,
    // TODO: Add permission check when available
  },
  {
    name: "courses tee boxes",
    path: "/golf/courses/tee-boxes",
    component: Courses,
    // TODO: Add permission check when available
  },
  {
    name: "courses scorecard",
    path: "/golf/courses/scorecard",
    component: Courses,
    // TODO: Add permission check when available
  },
  {
    name: "carts",
    path: "/golf/carts",
    component: Carts,
    // TODO: Add permission check when available
  },
  {
    name: "carts overview",
    path: "/golf/carts/overview",
    component: Carts,
    // TODO: Add permission check when available
  },
  {
    name: "carts assignments",
    path: "/golf/carts/assignments",
    component: Carts,
    // TODO: Add permission check when available
  },
  {
    name: "carts maintenance",
    path: "/golf/carts/maintenance",
    component: Carts,
    // TODO: Add permission check when available
  },
  {
    name: "carts map",
    path: "/golf/carts/map",
    component: Carts,
  },
  {
    name: "carts pace",
    path: "/golf/carts/pace",
    component: Carts,
  },
  {
    name: "carts beverage",
    path: "/golf/carts/beverage",
    component: Carts,
  },
  {
    name: "carts messaging",
    path: "/golf/carts/messaging",
    component: Carts,
  },
  {
    name: "carts telematics",
    path: "/golf/carts/telematics",
    component: Carts,
  },
  {
    name: "carts wash",
    path: "/golf/carts/wash",
    component: Carts,
  },
  {
    name: "carts incidents",
    path: "/golf/carts/incidents",
    component: Carts,
  },
  {
    name: "carts settings",
    path: "/golf/carts/settings",
    component: Carts,
  },
  {
    name: "caddies",
    path: "/golf/caddies",
    component: Caddies,
    // TODO: Add permission check when available
  },
  {
    name: "caddies overview",
    path: "/golf/caddies/overview",
    component: CaddiesOverview,
    // TODO: Add permission check when available
  },
  {
    name: "caddies availability",
    path: "/golf/caddies/availability",
    component: CaddiesAvailability,
    // TODO: Add permission check when available
  },
  {
    name: "caddies assignments",
    path: "/golf/caddies/assignments",
    component: CaddiesAssignments,
    // TODO: Add permission check when available
  },
  {
    name: "caddies schedule",
    path: "/golf/caddies/schedule",
    component: CaddiesSchedule,
  },
  {
    name: "caddies payroll",
    path: "/golf/caddies/payroll",
    component: CaddiesPayroll,
  },
  {
    name: "caddies certifications",
    path: "/golf/caddies/certifications",
    component: CaddiesCertifications,
  },
  {
    name: "caddies settings",
    path: "/golf/caddies/settings",
    component: CaddiesSettings,
    // TODO: Add permission check when available
  },
  {
    name: "weather",
    path: "/golf/weather",
    component: Weather,
    // TODO: Add permission check when available
  },
  {
    name: "staff scheduler",
    path: "/golf/staff",
    component: StaffScheduler,
    // TODO: Add permission check when available
  },
  {
    name: "staff timeoff",
    path: "/golf/staff/timeoff",
    component: StaffScheduler,
  },
  {
    name: "staff open-shifts",
    path: "/golf/staff/open-shifts",
    component: StaffScheduler,
  },
  {
    name: "staff team",
    path: "/golf/staff/team",
    component: StaffScheduler,
  },
  {
    name: "staff availability",
    path: "/golf/staff/availability",
    component: StaffScheduler,
  },
  {
    name: "staff payroll",
    path: "/golf/staff/payroll",
    component: StaffScheduler,
  },
  {
    name: "golf leagues",
    path: "/golf/leagues",
    component: GolfLeagues,
    // TODO: Add permission check when available
  },
  {
    name: "golf leagues overview",
    path: "/golf/leagues/overview",
    component: GolfLeaguesOverview,
    // TODO: Add permission check when available
  },
  {
    name: "golf leagues seasons",
    path: "/golf/leagues/seasons",
    component: GolfLeaguesSeasons,
    // TODO: Add permission check when available
  },
  {
    name: "golf leagues events",
    path: "/golf/leagues/events",
    component: GolfLeaguesEvents,
    // TODO: Add permission check when available
  },
  {
    name: "golf leagues standings",
    path: "/golf/leagues/standings",
    component: GolfLeaguesStandings,
    // TODO: Add permission check when available
  },
  {
    name: "golf leagues live",
    path: "/golf/leagues/live",
    component: GolfLeaguesLive,
  },
  {
    name: "golf leagues setup",
    path: "/golf/leagues/setup",
    component: GolfLeaguesSetup,
  },
  {
    name: "golf leagues member-guest",
    path: "/golf/leagues/member-guest",
    component: GolfLeaguesMemberGuest,
  },
  {
    name: "golf leagues member-guest detail",
    path: "/golf/leagues/member-guest/:id",
    component: GolfLeaguesMemberGuestDetail,
  },
  {
    name: "golf leagues member-guest calcutta",
    path: "/golf/leagues/member-guest/:id/calcutta",
    component: GolfLeaguesMemberGuestCalcutta,
  },
  {
    name: "golf leagues schedule",
    path: "/golf/leagues/schedule",
    component: GolfLeaguesSchedule,
  },
  {
    name: "golf leagues handicaps",
    path: "/golf/leagues/handicaps",
    component: GolfLeaguesHandicaps,
  },
  {
    name: "golf leagues bays",
    path: "/golf/leagues/bays",
    component: GolfLeaguesBays,
  },
  {
    name: "golf leagues comms",
    path: "/golf/leagues/comms",
    component: GolfLeaguesComms,
  },
  {
    name: "golf leagues side games",
    path: "/golf/leagues/side-games",
    component: GolfLeaguesSideGames,
  },
  {
    name: "golf leagues sponsorships",
    path: "/golf/leagues/sponsorships",
    component: GolfLeaguesSponsorships,
  },
  {
    name: "golf leagues pro shop",
    path: "/golf/leagues/pro-shop",
    component: GolfLeaguesProShop,
  },
  {
    name: "golf leagues pace",
    path: "/golf/leagues/pace",
    component: GolfLeaguesPace,
  },
  {
    name: "golf leagues network",
    path: "/golf/leagues/network",
    component: GolfLeaguesNetwork,
  },
  {
    name: "golf league detail",
    path: "/golf/leagues/:id",
    component: GolfLeagueDetail,
    // TODO: Add permission check when available
  },
  {
    name: "golf season detail",
    path: "/golf/leagues/seasons/:id",
    component: GolfSeasonDetail,
    // TODO: Add permission check when available
  },
  {
    name: "golf event detail",
    path: "/golf/leagues/events/:id",
    component: GolfEventDetail,
    // TODO: Add permission check when available
  },

  // New Caddies & Scheduling
  {
    name: "Caddy Roster",
    path: "/caddies",
    component: CaddyRosterPage,
    // permission: { resource: "Caddy Management", action: "view" },
  },
  {
    name: "Caddy Schedule",
    path: "/caddies/availability",
    component: CaddySchedulePage,
    // permission: { resource: "Caddy Management", action: "view" },
  },
  {
    name: "Staff Scheduling",
    path: "/staff-scheduling",
    component: StaffSchedulingPage,
    // permission: { resource: "Staff Scheduling", action: "view" },
  },
];

// public routes
export const publicRoutes = [
  { name: "Login", path: "/login", component: LoginPage },
  { name: "Select Account", path: "/select-account", component: AccountPicker },
  { name: "Register", path: "/register", component: RegisterPage },
  {
    name: "verification",
    path: "/verification",
    component: VerificationOtpPage,
  },
  { name: "confirmation", path: "/confirmation", component: ConfirmationPage },
  { name: "Reset Password", path: "/reset-password", component: ResetPassword },
  {
    name: "Password Verification",
    path: "/password-verification",
    component: PasswordVerification,
  },
  { name: "New Password", path: "/change-password/", component: NewPassword },
  { name: "User Invite", path: "/user-invite/", component: UserInvitePage },
  {
    name: "Google Callback",
    path: "/auth/google/callback",
    component: GoogleCallback,
  },
  { name: "Error Page", path: "*", component: Errorpage },
];
